export default __webpack_public_path__ + "static/media/HIGH-CHOLESTEROL.133e62fb.png";